<template>
    <div class="map-container">
        <div class="left-panel-container shadow-sm">
            <ul class="map-object-layer-list" v-if="mapObjects != null" v-bind:style="mapObjectLayersListStyle()">
                <li class="map-object-layer-container" v-for="mapObjectLayer of mapObjects" v-bind:key="mapObjectLayer.id">
                    <a v-bind:id="mapObjectCollapseId(mapObjectLayer) + '_toggle'" class="map-object-root collapsed" data-bs-toggle="collapse" v-bind:href="'#' + mapObjectCollapseId(mapObjectLayer)" v-on:click="handleMapObjectSelected(mapObjectLayer)">
                        <img class="collapsed-button" src="@/assets/buttons/expandButton.png" />
                        <img class="expanded-button" src="@/assets/buttons/collapseButton.png" />
                        {{ mapObjectName(mapObjectLayer) }}
                    </a>
                    <div class="map-object-layer-content collapse" v-bind:id="mapObjectCollapseId(mapObjectLayer)">

                        <ul class="map-object-list">
                            <li class="map-object-container" v-for="mapObject of mapObjectLayer.children" v-bind:key="mapObject.id">
                                <a href="#" v-on:click="handleMapObjectSelected(mapObject)">{{ mapObjectName(mapObject) }}</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
            <div class="map-object-edit-container" v-if="this.editedMapObject != null">
                <div class="toolbar">
                    <a href="#" v-on:click="handleBackFromEdition()"><img src="@/assets/buttons/backButton.png" /></a>
                    <span class="title">{{ mapObjectName(this.editedMapObject) }}</span>
                </div>
                <div class="content">
                    <div class="content-section">
                        <div class="title">{{ $t("admin.map.left_panel.status_section") }}</div>
                        <div class="dropdown">
                            <button class="btn btn-outline-secondary btn-sm dropdown-toggle" v-bind:style="mapObjectStatusButtonStyle(this.editedMapObject)" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                {{ mapObjectStatusTitleForMapObject(this.editedMapObject) }}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a href="#" class="dropdown-item" v-on:click="handleMapObjectStatusSelected(null)">{{ $t("admin.status.no_status") }}</a></li>
                                <li v-for="mapObjectStatusTemplate of this.mapObjectStatusTemplates" v-bind:key="mapObjectStatusTemplate.id">
                                    <a href="#" class="dropdown-item" v-on:click="handleMapObjectStatusSelected(mapObjectStatusTemplate)">{{ mapObjectStatusTemplateTitle(mapObjectStatusTemplate) }}</a>
                                </li>
                            </ul>
                        </div>
                        <div v-if="mapObjectStatusStringVisible(this.editedMapObject) && this.mapSpec.languageAvailability.english" class="multi-line-input">
                            <label class="form-label" for="detail_en">{{ $t("enums.languages.english") }}</label>
                            <textarea class="form-control" id="detail_en" rows="2" v-bind:placeholder="$t('admin.status.more_details')" v-model="englishStatusString" v-on:change="saveMapObjectStatus(null, true);"></textarea>
                        </div>
                        <div v-if="mapObjectStatusStringVisible(this.editedMapObject) && this.mapSpec.languageAvailability.french" class="multi-line-input">
                            <label class="form-label" for="detail_fr">{{ $t("enums.languages.french") }}</label>
                            <textarea class="form-control" id="detail_fr" rows="2" v-bind:placeholder="$t('admin.status.more_details')" v-model="frenchStatusString" v-on:change="saveMapObjectStatus(null, true);"></textarea>
                        </div>
                        <div class="extra-info">{{ $t("admin.map.left_panel.last_updated_on") }} {{ mapObjectStatusLastUpdate(this.editedMapObject) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-panel-container shadow-sm">
            <Map ref="mapboxMap" v-bind:mapSpec="mapSpec" v-bind:disableScrollZoom="false" v-bind:disableLeftPanel="true" v-bind:disableSearch="true" v-bind:hideOndagoLogo="true"></Map>
        </div>
    </div>
</template>

<script>
import Map from '@/views/ui/map/Map.vue'
import FromOMBMapSpec from '@/map/spec/FromOMBMapSpec'
import MapService from '@/service/MapService'
import MapObjectStatusService from '@/service/MapObjectStatusService'
import LangUtils from '@/utils/LangUtils'
import MapObjectStatus from '@/model/MapObjectStatus'
import * as tinycolor from 'tinycolor2';
import * as moment from 'moment';

export default {
    name: "MapEditor",

    components: {
        Map
    },

    props: {
        publisherId: null,
        mapId: null,
        objectId: null
    },

    data() {
        return {
            mapSpec: null,
            mapObjects: null,
            selectedMapObject: null,
            editedMapObject: null,
            mapObjectStatusTemplates: null,
            allMapObjectStatus: null,

            mapService: new MapService(),
            mapObjectStatusService: new MapObjectStatusService(this.$i18n.locale),

            editedCount: 0
        }
    },

    computed: {
        englishStatusString: {
            get: function() {
                this.editedCount;
                return this.getMapObjectStatusString(this.editedMapObject, "en");
            },

            set: function(newValue) {
                this.setMapObjectStatusString(this.editedMapObject, "en", newValue);
                this.editedCount ++;
            }
        },

        frenchStatusString: {
            get: function() {
                this.editedCount;
                return this.getMapObjectStatusString(this.editedMapObject, "fr");
            },

            set: function(newValue) {
                this.setMapObjectStatusString(this.editedMapObject, "fr", newValue);
                this.editedCount ++;
            }
        }
    },

    methods: {
        loadMapObjects() {
            return new Promise((resolve) => {
                this.mapObjects = this.mapSpec.mapObjectStructure;
                resolve();
            });
        },

        loadMapObjectStatusTemplates() {
            return new Promise((resolve, reject) => {
                if (this.publisherId != null) {
                    this.mapObjectStatusService.loadMapObjectStatusTemplates(this.publisherId, true).then((mapObjectStatusTemplates) => {
                        this.mapObjectStatusTemplates = mapObjectStatusTemplates;
                        resolve();
                    }).catch((error) => {
                        reject(error);
                    });
                } else {
                    resolve();
                }
            });
        },

        loadMapObjectStatus() {
            return new Promise((resolve, reject) => {
                if (this.publisherId && this.mapId) {
                    this.mapService.loadMapObjectStatusForMap(this.publisherId, this.mapId).then((allMapObjectStatus) => {
                        this.allMapObjectStatus = allMapObjectStatus;
                        resolve();
                    }).catch((error) => {
                        console.log(error);
                        reject(error);
                    });
                } else {
                    resolve();
                }
            });
        },

        saveMapObjectStatus(mapObjectStatusTemplate = null, statusStringChanged = false) {
            if (this.editedMapObject) {
                const mapObjects = [ this.editedMapObject ];

                if (mapObjectStatusTemplate || statusStringChanged) {
                    const mapObjectStatusToSave = [];
                    for (var mapObject of mapObjects) {
                        var status = this.findMapObjectStatusForMapObject(mapObject.uid);
                        if (!status) {
                            status = new MapObjectStatus();
                            status.mapIds = {};
                            status.mapIds[this.mapId] = true;
                            status.mapObjectId = mapObject.uid;
                            this.allMapObjectStatus.push(status);
                        }

                        if (mapObjectStatusTemplate) {
                            status.mapObjectStatusTemplateId = mapObjectStatusTemplate.id;
                        }

                        status.lastUpdate = new Date().getTime();

                        mapObjectStatusToSave.push(status);
                    }
                    this.mapService.saveMapObjectStatusArray(this.publisherId, mapObjectStatusToSave).then(() => {
                        this.$forceUpdate();

                        const mapObjectStatusDataStream = this.mapSpec.mapObjectStatusDataStream;
                        if (mapObjectStatusDataStream) {
                            for (var mapObjectStatus of mapObjectStatusToSave) {
                                mapObjectStatusDataStream.addOrUpdateMapObjectStatus(mapObjectStatus);
                            }
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    const mapObjectStatusIdsToDelete = [];
                    
                    for (mapObject of mapObjects) {
                        const status = this.findMapObjectStatusForMapObject(mapObject.uid);
                        if (status) {
                            mapObjectStatusIdsToDelete.push(status.id);
                            this.allMapObjectStatus.splice(this.allMapObjectStatus.indexOf(status), 1);
                        }
                    }

                    if (mapObjectStatusIdsToDelete.length > 0) {
                        this.mapService.deleteMapObjectStatus(this.publisherId, mapObjectStatusIdsToDelete).then(() => {
                            const mapObjectStatusDataStream = this.mapSpec.mapObjectStatusDataStream;
                            if (mapObjectStatusDataStream) {
                                for (const mapObjectStatusId of mapObjectStatusIdsToDelete) {
                                    mapObjectStatusDataStream.removeMapObjectStatus(mapObjectStatusId);
                                }
                            }
                        }).catch((error) => {
                            console.log(error);
                        });
                    }
                }
            }
        },

        mapObjectName(mapObject) {
            return LangUtils.valueForLanguage(mapObject.name, this.$i18n.locale);
        },

        mapObjectCollapseId(mapObject) {
            var id = mapObject.id;
            if (!id) {
                id = mapObject.uid;
                if (!id) {
                    id = mapObject.uniqueIdentifier;
                    if (!id) {
                        id = LangUtils.valueForLanguage(mapObject.name, this.$i18n.locale);
                    }
                }
            }

            if (id) {
                id = id.replaceAll("'", "_").replaceAll(" ", "_");
            }

            return "collapse_" + encodeURI(id).replaceAll("%", "").replaceAll("(", "").replaceAll(")", "").replaceAll("/", "").replaceAll("\\", "");
        },

        mapObjectStatusTemplateTitle(mapObjectStatusTemplate) {
            return LangUtils.valueForLanguage(mapObjectStatusTemplate.title, this.$i18n.locale);
        },

        mapObjectStatusTitleForMapObject(mapObject) {
            if (mapObject) {
                const mapObjectStatus = this.findMapObjectStatusForMapObject(mapObject.uid);
                if (mapObjectStatus) {
                    const mapObjectStatusTemplate = this.findMapObjectStatusTemplate(mapObjectStatus.mapObjectStatusTemplateId);
                    if (mapObjectStatusTemplate) {
                        return LangUtils.valueForLanguage(mapObjectStatusTemplate.title, this.$i18n.locale);
                    } else {
                        return this.$t("admin.status.unknown_status");
                    }
                } else {
                    return this.$t("admin.status.no_status");
                }
            } else {
                return "";
            }
        },

        mapObjectStatusButtonStyle(mapObject) {
            if (mapObject) {
                const mapObjectStatus = this.findMapObjectStatusForMapObject(mapObject.uid);
                if (mapObjectStatus) {
                    const mapObjectStatusTemplate = this.findMapObjectStatusTemplate(mapObjectStatus.mapObjectStatusTemplateId);
                    if (mapObjectStatusTemplate) {
                        const color = mapObjectStatusTemplate.color;

                        var fontColor = "#ffffff";
                        var borderColor = color;
                        var backgroundColor = color;

                        if (tinycolor(color).getBrightness() > 205) {
                            fontColor = tinycolor(color).darken(100);
                            borderColor = tinycolor(color).darken(5);
                        }

                        return "color: " + fontColor + "; border-color: " + borderColor + "; background-color: " + backgroundColor + ";";
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            }
        },

        mapObjectLayersListStyle() {
            return this.editedMapObject != null ? "display: none;" : "display: block;";
        },

        mapObjectStatusLastUpdate(mapObject) {
            const status = this.findMapObjectStatusForMapObject(mapObject.uid);
            if (status) {
                if (status.lastUpdate) {
                    return moment(new Date(status.lastUpdate)).format("YYYY-MM-DD hh:mm");
                } else {
                    return this.$t("admin.status.not_available_message");
                }
            } else {
                return this.$t("admin.status.no_status_message");
            }
        },

        mapObjectStatusStringVisible(mapObject) {
            return this.findMapObjectStatusForMapObject(mapObject.uid) != null;
        },

        getMapObjectStatusString(mapObject, language) {
            if (mapObject) {
                const status = this.findMapObjectStatusForMapObject(mapObject.uid);
                if (status) {
                    if (status.statusString) {
                        return status.statusString[language];
                    }
                }
            }
            return "";
        },

        setMapObjectStatusString(mapObject, language, newValue) {
            if (mapObject) {
                const status = this.findMapObjectStatusForMapObject(mapObject.uid, true);
                if (status) {
                    if (!status.statusString) {
                        status.statusString = {};
                    }

                    status.statusString[language] = newValue;
                }
            }
        },

        findMasterMapObjectById(mapObjectId, mapObjects) {
            if (mapObjectId != null) {
                for (var layerMapObject of mapObjects) {
                    const mapObjects = layerMapObject.children;
                    for (var mapObject of mapObjects) {
                        if (this.isMapObjectContainingMapObject(mapObject, mapObjectId)) {
                            return mapObject;
                        }
                    }
                }

                return null;
            } else {
                return null;
            }
        },

        isMapObjectContainingMapObject(mapObject, childMapObjectId) {
            if (mapObject.uid == childMapObjectId) {
                return true;
            }

            if (mapObject.children && mapObject.children.length > 0) {
                for (var child of mapObject.children) {
                    const result = this.isMapObjectContainingMapObject(child, childMapObjectId);
                    if (result == true) {
                        return true;
                    }
                }

                return false;
            } else {
                return false;
            }
        },

        findMapObjectStatusForMapObject(mapObjectId, createIfNotFound = false) {
            if (this.allMapObjectStatus) {
                for (var mapObjectStatus of this.allMapObjectStatus) {
                    if (mapObjectStatus.mapObjectId == mapObjectId) {
                        return mapObjectStatus;
                    }
                }
            }

            if (createIfNotFound) {
                var status = new MapObjectStatus();
                status.mapIds = {};
                status.mapIds[this.mapId] = true;
                status.mapObjectId = mapObjectId;
                this.allMapObjectStatus.push(status);
            }

            return null;
        },

        findMapObjectStatusTemplate(mapObjectStatusTemplateId) {
            for (var mapObjectStatusTemplate of this.mapObjectStatusTemplates) {
                if (mapObjectStatusTemplate.id === mapObjectStatusTemplateId) {
                    return mapObjectStatusTemplate;
                }
            }

            return null;
        },

        handleMapObjectSelected(mapObject) {
            const collapseId = this.mapObjectCollapseId(mapObject);
            const collapseToggle = document.getElementById(collapseId + "_toggle");
            if (collapseToggle) {
                const expanded = collapseToggle.getAttribute("aria-expanded");

                if (expanded == "true") {
                    this.selectedMapObject = mapObject;
                }
            } else {
                this.editedMapObject = mapObject;
            }

            this.$refs.mapboxMap.selectMapElement(mapObject.uid, true, false);
        },

        handleMapObjectSelectedOnMap(mapObjectId) {
            const masterMapObject = this.findMasterMapObjectById(mapObjectId, this.mapObjects);
            if (masterMapObject) {
                this.editedMapObject = masterMapObject;
            }
        },

        handleBackFromEdition() {
            this.editedMapObject = null;
        },

        handleMapObjectStatusSelected(mapObjectStatusTemplate) {
            this.saveMapObjectStatus(mapObjectStatusTemplate);
        }
    },

    mounted() {
        if (this.publisherId && this.mapId) {
            this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                var selectedBundleId = null;
                if (map.bundleIds) {
                    for (var bundleId in map.bundleIds) {
                        if (map.bundleIds[bundleId]) {
                            selectedBundleId = bundleId;
                            break;
                        }
                    }
                }

                this.mapSpec = new FromOMBMapSpec(this.$store.state.currentUser, this.publisherId, selectedBundleId, this.mapId, this.$i18n.locale, this.$i18n);
                this.mapSpec.load(true, false, true).then(() => {
                    const allPromises = [];
                    allPromises.push(this.loadMapObjectStatusTemplates());
                    allPromises.push(this.loadMapObjects());
                    allPromises.push(this.loadMapObjectStatus());

                    Promise.all(allPromises).then(() => {
                        if (this.$refs.mapboxMap) {
                            this.$refs.mapboxMap.refresh();
                        }

                        if (this.objectId) {
                            this.$refs.mapboxMap.selectMapElement(this.objectId, true, true, true);
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                }).catch((error) => {
                    console.log(error);
                });

                this.$root.$on("onMapElementSelected", (data) => {
                    if (data && data.id) {
                        this.handleMapObjectSelectedOnMap(data.id);
                    }
                });
            }).catch((error) => {
                console.log(error);
            });
        }
    }
}
</script>

<style scoped>
.map-container {
    display: grid;
    column-gap: 8px;
    grid-template-columns: 300px auto;
    justify-items: stretch;
    align-items: stretch;
    width: 100%;
    height: 100%;
}

.left-panel-container {
    background-color: #ffffff;
    overflow: scroll;
}

.right-panel-container {
    background-color: #ffffff;
}

.map-object-layer-list {
    list-style-type: none;
    margin-top: 24px;
    padding: 0px 16px;
    text-align: left;
}

.map-object-layer-container {
    margin-top: 8px;
}

.map-object-root {
    display: block;
    font-weight: bold;
    text-decoration: none;
}

.map-object-root img {
    height: 15px;
}

.map-object-layer-container {
    background: #f9f9f9;
    font-size: 14px;
}

.map-object-layer-container .collapsed {
    background: #ffffff;
    font-weight: normal;
}

.map-object-layer-container .collapsed-button {
    display: none;
}

.map-object-layer-container .collapsed .collapsed-button {
    display: inline-block;
}

.map-object-layer-container .collapsed .expanded-button {
    display: none;
}

.map-object-layer-content {
    background: #f9f9f9;
    padding: 8px 16px;
}

.map-object-layer-content .section .title {
    font-weight: bold;
}

.map-object-layer-content .status-section button {
    margin-right: 8px;
}

.map-object-list {
    list-style-type: none;
    padding: 0px;
}

.map-object-container {
    font-size: 14px;
    margin-bottom: 8px;
}

.map-object-container a {
    text-decoration: none;
}

.map-object-container a:hover {
    text-decoration: underline
}

.map-object-edit-container {
    padding: 8px 0px;
}

.map-object-edit-container .toolbar {
    border-bottom: 1px solid #aaaaaa;
    padding: 8px;
}

.map-object-edit-container .toolbar img {
    width: 25px;
}

.map-object-edit-container .title {
    font-size: 14px;
    font-weight: bold;
    margin-left: 8px;
}

.map-object-edit-container .content {
    margin-top: 8px;
}

.map-object-edit-container .content .content-section {
    border-bottom: 1px solid #efefef;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
}

.map-object-edit-container .content .content-section .title {
    margin-left: 0px;
}

.map-object-edit-container .content .content-section .form-label {
    margin-bottom: 0px;
}

.map-object-edit-container .content .content-section .dropdown {
    display: inline-block;
}

.map-object-edit-container .content .content-section .dropdown button {
    font-size: 14px;
}

.map-object-edit-container .content .content-section .multi-line-input {
    margin-top: 8px;
}

.map-object-edit-container .content .content-section .extra-info {
    font-size: 12px;
    margin-top: 8px;
}
</style>